import React from 'react';
import ModalContactSupportView from './ModalContactSupport-view';
import {downloadFile} from "../../utils/files/downloadFile";
import PropTypes from "prop-types";
import appConfig from '../../../config/common';

const ModalContactSupport = ({
                               showLabelIcon = false,
                               customLabelStyles,
                               showGlobalErrorMessage
                             }) => {

  const downloadPDFlink = appConfig.download_pdf_api.base_URL;

  const handleDownloadPDF = () => {
    Promise.resolve()
      .then(() => {
        downloadFile(downloadPDFlink, '', false);
      })
      .catch(error => showGlobalErrorMessage(error.message))
  }

  return (
    <ModalContactSupportView
      showLabelIcon={showLabelIcon}
      customLabelStyles={customLabelStyles}
      handleDownloadPDF={handleDownloadPDF}
    />
  );
};

ModalContactSupport.propTypes = {
  showLabelIcon: PropTypes.bool,
};

export default ModalContactSupport;
